import { OffCanvasState } from '../interfaces/off-canvas.interface';
import { createSlice } from '@reduxjs/toolkit';

/*----- CREATE INITIAL STATE ------*/

export const offCanvasInitialState: OffCanvasState = {
  clearAction: undefined,
  closeAction: undefined,
  focusInAction: undefined,
  focusOutAction: undefined,
  openAction: undefined,
  data: undefined,
};

/*----- CREATE STORE SLICE ------*/

export const offCanvasSlice = createSlice({
  name: 'offCanvas',
  initialState: offCanvasInitialState,
  reducers: {
    sendOffCanvasData: (state, action): void => {
      if (!action.payload?.offCanvasId || !action.payload?.data) {
        return;
      }

      if (!state.data) {
        state.data = {};
      }
      state.data[action.payload.offCanvasId] = action.payload.data;
    },
    triggerOpenOffCanvas: (state, action): void => {
      state.openAction = action.payload;
    },
    triggerOpenOffCanvasDismiss: (state): void => {
      state.openAction = undefined;
    },
    triggerClearOffCanvas: (state, action): void => {
      state.clearAction = action.payload;
    },
    triggerClearOffCanvasDismiss: (state): void => {
      state.clearAction = undefined;
    },
    triggerCloseOffCanvas: (state, action): void => {
      state.closeAction = action.payload;
    },
    triggerCloseOffCanvasDismiss: (state): void => {
      state.closeAction = undefined;
    },
    triggerFocusInOffCanvas: (state, action): void => {
      state.focusInAction = action.payload;
    },
    triggerFocusInOffCanvasDismiss: (state): void => {
      state.focusInAction = undefined;
    },
    triggerFocusOutOffCanvas: (state, action): void => {
      state.focusOutAction = action.payload;
    },
    triggerFocusOutOffCanvasDismiss: (state): void => {
      state.focusOutAction = undefined;
    },
  },
});

/*----- CREATE SLICE ACTIONS ------*/

export const {
  sendOffCanvasData,
  triggerClearOffCanvas,
  triggerClearOffCanvasDismiss,
  triggerCloseOffCanvas,
  triggerCloseOffCanvasDismiss,
  triggerFocusInOffCanvas,
  triggerFocusInOffCanvasDismiss,
  triggerFocusOutOffCanvas,
  triggerFocusOutOffCanvasDismiss,
  triggerOpenOffCanvas,
  triggerOpenOffCanvasDismiss,
} = offCanvasSlice.actions;

/*----- CREATE REDUCER ------*/

export const offCanvasReducer = offCanvasSlice.reducer;
